import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  // 更换  路由 LiyingqiTravelCase名字时候记得 vue.config.js里面的publicPath 也需要换偶
  // 案例一
  {
    path: '/',
    component: () => import('../views/index.vue'),
    redirect: '/info',
    children: [
      {
        path: '/info',
        component: () => import('../views/apply/info.vue')
      },
      {
        path: '/experience',
        component: () => import('../views/apply/experience.vue')
      },
      {
        path: '/research',
        component: () => import('../views/apply/research.vue')
      },
      {
        path: '/formSubmit',
        component: () => import('../views/apply/formSubmit.vue')
      },
      {
        path: '/integrity',
        component: () => import('../views/apply/integrity.vue')
      },
      {
        path: '/dict',
        component: () => import('../views/apply/dict.vue')
      },
      {
        path: '/talentManage',
        component: () => import('../views/apply/talentManage.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'login/',
    component: () => import('../views/login.vue')
  }
]
const router = new VueRouter({
  mode: '',
  base: '/',
  routes
})
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('Token3')
  if (token && to.path !== '/login') {
    // 有token 但不是去 login页面 通过
    next()
  } else if (token && to.path === '/login') {
    // 有token 但是去 login页面 不通过 重定向到首页
    next('/')
  } else if (!token && to.path !== '/login') {
    // 没有token 但不是去 login页面 不通过（未登录不给进入）
    console.log(to.path)
    if (to.path === '/enroll') {
      // 没有token 但不是去 login页面 不通过（未登录不给进入）
      next(true)
    } else {
      next('/login')
    }
  } else {
    // 剩下最后一种 没有token 但是去 login页面 通过
    next()
  }
})

export default router
